module.exports = __webpack_public_path__ + "img/slide-3.9317ff84.webp";